'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.default = search;
exports.autocomplete = autocomplete;
exports.clear = clear;
exports.isLoaded = isLoaded;
exports.isLoading = isLoading;

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

var _preludeExtension = require('prelude-extension');

var _unidecode = require('unidecode');

var _unidecode2 = _interopRequireDefault(_unidecode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLEAR = 'caligram/search/CLEAR';
var SEARCH = 'caligram/search/SEARCH';
var SEARCH_SUCCESS = 'caligram/search/SEARCH_SUCCESS';
var SEARCH_FAIL = 'caligram/search/SEARCH_FAIL';

var initialState = {
  loaded: false,
  loading: false,
  promise: null,
  items: []
};

function search() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  function parseResults(result, query) {
    var suggestions = [];

    (0, _keys2.default)(result).map(function (section) {
      suggestions.push({
        title: section,
        data: result[section].data.map(function (item) {
          return {
            id: item.id,
            slug: item.slug,
            label: item.name,
            group: section,
            image: item.image,
            venue: item.venue,
            labelPartitions: (0, _preludeExtension.partitionString)((0, _unidecode2.default)(item.name).toLowerCase(), (0, _unidecode2.default)(query).toLowerCase())
          };
        })
      });
    });

    return suggestions;
  }

  switch (action.type) {
    case CLEAR:
      return (0, _extends3.default)({}, state, {
        items: []
      });
    case SEARCH:
      if (state.promise && state.promise.cancel) {
        state.promise.cancel();
      }
      return (0, _extends3.default)({}, state, {
        loaded: false,
        loading: true,
        promise: action.promise
      });
    case SEARCH_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loaded: true,
        loading: false,
        items: parseResults(action.result, action.query),
        promise: null
      });
    case SEARCH_FAIL:
      return (0, _extends3.default)({}, state, {
        loaded: false,
        loading: false,
        error: action.error,
        promise: null
      });
    default:
      return state;
  }
}

function autocomplete(input, searchIn, extra) {
  var params = { q: input };
  if (searchIn && searchIn.length) {
    params = (0, _extends3.default)({}, params, extra, {
      searchIn: (typeof searchIn === 'undefined' ? 'undefined' : (0, _typeof3.default)(searchIn)) === 'object' ? searchIn.join(',') : searchIn
    });
  }

  return {
    types: [SEARCH, SEARCH_SUCCESS, SEARCH_FAIL],
    query: input,
    promise: function promise(client) {
      return client.get('/search?' + _queryString2.default.stringify(params));
    }
  };
}

function clear() {
  return {
    type: CLEAR
  };
}

function isLoaded(globalState) {
  return globalState.search && globalState.search.loaded;
}

function isLoading(globalState) {
  return globalState.search && globalState.search.loading;
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/search.js
// module id = 642
// module chunks = 0